/* eslint-disable react/no-danger */
/* eslint-disable jam3/no-sanitizer-with-danger */

import React, { ReactElement } from 'react';

import { Alert, Divider } from 'elmo-elements';
import DOMPurify from 'dompurify';

interface QuestionFeedbackType {
  correct: string;
  inCorrect: string;
}
export interface FeedbackPropType {
  isAnswerCorrect: boolean | undefined;
  selectedAnswer: any;
  correctAnswer: string | Array<string>;
  questionFeedback: QuestionFeedbackType;
  showCorrectAnswer: number | undefined;
  showFeedback: number | undefined;
  questionType: number | undefined;
}

const printAnswersDndMatch = (answers: string | Array<string>) =>
  Array.isArray(answers) ? (
    <>
      <p className="feedback-list">The correct answers are: </p>
      <br />
      <div className="feedback-list-answers">
        <dl className="feedback-list-answers__dnd-match">
          {answers.map((answer: string, index: number) =>
            index % 2 ? (
              <dd key={index}>{answer}</dd>
            ) : (
              <dt key={index}>
                <span>
                  {`${Math.round(index / 2) + 1}. `}{' '}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(answer),
                    }}
                  />
                </span>
              </dt>
            ),
          )}
        </dl>
      </div>
    </>
  ) : (
    <div />
  );

const printAnswers = (answers: string | Array<string>) => {
  if (Array.isArray(answers) && answers.length) {
    if (answers.length === 1) {
      return (
        <p>
          The correct answer is:{' '}
          {answers.map((answer: string, index: number) => (
            <b
              key={index}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(answer),
              }}
            />
          ))}
        </p>
      );
    }

    return (
      <>
        <p className="feedback-list">The correct answers are: </p>
        <br />
        <div className="feedback-list-answers">
          {answers.map((answer: string, index: number) => (
            <p key={index}>
              {`${index + 1}. `}{' '}
              <b
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(answer),
                }}
              />
            </p>
          ))}
        </div>
      </>
    );
  }

  return (
    <p>
      The correct answer is:{' '}
      <b
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(answers as string),
        }}
      />
    </p>
  );
};

const Feedback = ({
  isAnswerCorrect,
  selectedAnswer,
  correctAnswer,
  questionFeedback,
  showCorrectAnswer,
  showFeedback,
  questionType,
}: FeedbackPropType): ReactElement => (
  <div id="feedback-info" className="answer-incorrect">
    <Alert
      heading={isAnswerCorrect ? 'Correct' : 'Incorrect'}
      isCloseable={false}
      type={isAnswerCorrect ? 'success' : 'danger'}
      role="alert"
    >
      {selectedAnswer ? (
        <p>
          You selected Option {selectedAnswer?.option}:
          <b
            className="ml-2"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(selectedAnswer?.data.content),
            }}
          />
        </p>
      ) : (
        ''
      )}
      {showCorrectAnswer === 1 &&
        isAnswerCorrect === false &&
        (questionType === 4
          ? printAnswersDndMatch(correctAnswer)
          : printAnswers(correctAnswer))}

      {(questionFeedback.correct || questionFeedback.inCorrect) && (
        <div className="mt-3 mb-3">
          <Divider />
        </div>
      )}
      {showFeedback === 1 &&
        isAnswerCorrect === true &&
        questionFeedback.correct !== '' && (
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(questionFeedback.correct),
            }}
          />
        )}
      {showFeedback === 1 &&
        isAnswerCorrect === false &&
        questionFeedback.inCorrect !== '' && (
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(questionFeedback.inCorrect),
            }}
          />
        )}
    </Alert>

    <div />
  </div>
);

export default Feedback;
